export default "__VITE_ASSET__WbA46KvV__"